import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewUserComponent } from './new-user.component';
import { SharedModule } from '../../shared/shared.module';
import { APIJoinFlowService } from '../../core/services/API/APIJoinFlow.service';
import { JoinFormComponent } from './join-form/join-form.component';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../material.module';
import { TokenService } from '../../core/services/auth/token.service';

@NgModule({
  declarations: [
    NewUserComponent,
    JoinFormComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MaterialModule,
],
  providers: [
    APIJoinFlowService,
    TokenService
  ]
})
export class NewUserModule { }
